import React, { useCallback, useEffect, useState,useRef } from "react";
import Layout from "../../Layout/Layout";
import "react-quill/dist/quill.snow.css";
import {
    categoriesList,
} from "../../../apiService/category.service";
import { getPreviousDate } from "../../utils/dateFormate";
import articleService from "../../../apiService/article.service";
import { useLocation } from "react-router-dom";
import { convertDateToFormat, validateDates } from "../../utils/utils";
import toast, { Toaster } from "react-hot-toast";
import FilterSection from "../../../base/FilterSection";
import DataTable from "../../../base/DataTable";
import Pagination from "../../../base/Pagination";





export const SignInMethodData = [
    ["Total", "Total Users"],
    ["google", 85974],
    ["mobile", 59727],
];

export const UserMethodData = [
    ["Total", "Total Users"],
    ["Casual", 85974],
    ["Loyal", 59727],
    ["Brand", 29720],
];

export const PieHoleOption = {
    pieHole: 0.56,
    is3D: false,
    legend: "none",
    chartArea: {
        left: 10,
        right: 10, // !!! works !!!
        bottom: 20, // !!! works !!!
        top: 20,
        width: "100%",
        height: "100%",
    },
};

const categoryTitle = [
    {
        id: '1',
        title: 'ID',
    },
    {
        id: '2',
        title: 'URL',
    },
    {
        id: '3',
        title: 'PV',
    },
    {
        id: '4',
        title: 'User',
    },
    {
        id: '5',
        title: 'New Users',
    },
    {
        id: '6',
        title: 'Returning Users',
    },
]

function Categories() {
    const { state } = useLocation();
    const [domainList, setDomainList] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState();
    const [categoriesData, setCategoriesData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [onLastPage, setOnLastPage] = useState(false);
    const [dateValue, setDateValue] = useState({ startDate: null, endDate: null });
    const initialized = useRef(false)    

    const articleCategories = useCallback(async (pageNo=1, cat) => {
        if(pageNo !== 0){
        setPage(pageNo);
        }
        setIsLoading(true);

        try {
            const response = await articleService(state?.domain, 10, pageNo, {
                startDate: !dateValue.startDate ? getPreviousDate() : convertDateToFormat(dateValue.startDate),
                endDate: !dateValue.endDate ? getPreviousDate() : convertDateToFormat(dateValue.endDate),
                isRegistered: state?.isRegistered,
                ...(cat ? { category: cat } : {category: state?.category}),
            },  state?.apiKey);

            if (response.data?.articleList?.length) {
                const articleCount = response.data.articleList.length;
                setOnLastPage(articleCount < 10);
                setHasMore(articleCount >= 10);
                setCategoriesData(prev => [...response.data.articleList]);
            }
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching articles: ", error);
            setIsLoading(false);
        }
    }, [page, selectedDomain, state?.domain, state?.category, dateValue.startDate, dateValue.endDate]);
    
    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            run()
          }
    }, []); 

    console.log('response',state);
    const run=async()=>{
        getCategoriesList();
        articleCategories(page);
    }

      const getCategoriesList = useCallback(async () => {
            try {
                const response = await categoriesList(state?.domain, 
                getPreviousDate(),
                getPreviousDate(),  {
                    authorId: state?.authorId,
                    isRegistered: state?.isRegistered
                },  state?.apiKey);

                console.log('response',response);
                
                const categoryList = response?.categoryList || [];
                const extendedCategoryList = [{ category: "All" }, ...categoryList];
                setDomainList(extendedCategoryList);
                let getCategoryIndex;
                if (state?.category) {
                    getCategoryIndex = extendedCategoryList.find(
                        (category) => category.category === state?.category
                    );
                }
                setSelectedDomain(getCategoryIndex?.category || "All");
            } catch (error) {
                console.log(error);
            }
        }, []);

    const handleChange = (e) => {
        const selectedCategory = domainList.find((list) => list.category === e.category);
        setSelectedDomain(selectedCategory?.category);
        setCategoriesData([]);
        articleCategories(1, selectedCategory?.category);
    }

    const onDateFilterApply = async () => {
        setCategoriesData([]);
        await articleCategories(1);
    }
// 
    const onNextPage = () => {
        if (!onLastPage && hasMore) {
            setCategoriesData([]);
            articleCategories(page + 1);
        }
    }

    const onPreviousPage = () => {
        if(page === 1){
            return
        }
        setCategoriesData([]);
        articleCategories(page - 1);
    };

    const onDateSelect = (date) => {
        let isValidDate;
        if (date.startDate !== null) {
            isValidDate = validateDates(convertDateToFormat(date.startDate))
        }

        if(isValidDate?.isValid === true) {
            setDateValue(date)
        } else if(isValidDate?.isValid === false) {
            return toast.error(isValidDate?.message)
        }
    }

    return (
        <Layout>
            <main>
                <Toaster />
                <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
                    {/* <div className='flex justify-center mb-6'>
                        <nav className="flex divide-x divide-gray-200 rounded-lg shadow overflow-hidden">
                            <a
                                href="/cdp/anonymous"
                                className="text-gray-50 hover:text-gray-50 group relative min-w-0 flex-1 overflow-hidden bg-red-500 hover:bg-red-600 px-8 py-4 text-center text-sm font-bold uppercase focus:z-10"
                            >
                                <span>Anonymous</span>
                                <span
                                    aria-hidden="true"
                                    className="bg-red-500 absolute inset-x-0 bottom-0 h-0.5"
                                />
                            </a>
                            <a
                                href="/cdp/anonymous/registered"
                                className="text-gray-500 hover:text-gray-500 group relative min-w-0 flex-1 overflow-hidden bg-gray-50 hover:bg-gray-100 px-8 py-4 text-center text-sm font-bold uppercase focus:z-10"
                            >
                                <span>Registered</span>
                                <span
                                    aria-hidden="true"
                                    className="absolute inset-x-0 bottom-0 h-0.5"
                                />
                            </a>
                        </nav>
                    </div> */}
                    <div className="text-gray-50 bg-white rounded-2xl shadow-lg">
                        <div className="mx-auto">

                            <FilterSection 
                                title={state?.category}
                                selectedDomain={selectedDomain}
                                domainList={domainList}
                                dateValue={dateValue}
                                handleChange={handleChange}
                                onDateSelect={onDateSelect}
                                onDateFilterApply={onDateFilterApply}
                            />
                            
                            <DataTable categoryTitle={categoryTitle} categoriesData={categoriesData} isLoading={isLoading} />
                            
                            <Pagination page={page} onNextPage={onNextPage} onPreviousPage={onPreviousPage} />
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
}
export default React.memo(Categories)